module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av168-42d3e69295553f3ccb2f48e270f1e6c2.jpg";